import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedJobAdsBySlug = async (slug, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  try {
    const {
      data: { data: jobAds, total },
    } = await axios.get(`/api/public/companies/${slug}/job_ads?${queryString}`);

    return { jobAds, total };
  } catch (error) {
    console.log(error);
  }

  return { jobAds: [], total: 0 };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  acceptingOffers: false,
  sortBy: 'dateCreated',
  queryKey: ['companies-related-job-ads-by-slug'],
  queryOptions: {},
};

export const useGetRelatedJobAdsBySlug = (slug, queryParams = {}) => {
  const { page, limit, search, includeInactive, acceptingOffers, sortBy, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: !acceptingOffers,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, slug],
    () => getRelatedJobAdsBySlug(slug, queryStringParams),
    {
      select: ({ jobAds, total }) => ({ jobAds, total }),
      initialData: { jobAds: [], total: 0 },
      ...queryOptions,
    }
  );
}